import { createSelector } from "@reduxjs/toolkit";
import { initialState, type AppointmentsState } from "./slice";

const selectSlice = (state: {
  appointments?: AppointmentsState;
}): AppointmentsState => state.appointments || initialState;

export const selectCount = createSelector(
  [selectSlice],
  (state) => state.count,
);

export const selectAppointmentsList = createSelector(
  [selectSlice],
  (state) => state.list,
);

export const selectAppointmentDetails = createSelector(
  [selectSlice],
  (state) => state.details,
);
